import React, { useState, useEffect } from "react";
import { FiSearch, FiExternalLink } from "react-icons/fi";
import { useAuth } from "../../contexts/AuthContext";
import { useData } from "../../contexts/DataContext";
import { format } from "date-fns";

// Safe date converter (handles Firestore Timestamps)
const toDate = v => { if(!v) return new Date(); if(typeof v?.toDate==="function") return v.toDate(); return new Date(v); };





const TYPE_ICON  = { pdf:"📄", doc:"📝", video:"🎥", slides:"📊", image:"🖼️", other:"🔗" };
const TYPE_COLOR = { pdf:"#dc2626", doc:"#2563eb", video:"#dc2626", slides:"#d97706", image:"#059669", other:"#7c3aed" };

export default function StudentMaterials() {
  const { userData } = useAuth();
  const { getMaterials } = useData();
  const [materials, setMaterials] = useState([]);
  const [loading, setLoading]     = useState(true);
  const [search, setSearch]       = useState("");
  const [sub, setSub]             = useState("all");

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { getMaterials({ classId: userData?.class }).then(d => { setMaterials(d); setLoading(false); }); }, []);

  const subjects = [...new Set(materials.map(m => m.subject))];
  const filtered = materials.filter(m =>
    (sub === "all" || m.subject === sub) &&
    (m.title.toLowerCase().includes(search.toLowerCase()) || m.subject.toLowerCase().includes(search.toLowerCase()))
  );

  return (
    <div className="fade-in">
      <div className="page-head">
        <div>
          <h1 className="page-title">📖 Study Materials</h1>
          <p className="page-subtitle">{filtered.length} resources from your teachers</p>
        </div>
      </div>
      <div style={{ display: "flex", gap: 10, marginBottom: 18, flexWrap: "wrap" }}>
        <div className="search-box" style={{ flex: 1, minWidth: 200 }}>
          <FiSearch className="search-icon" size={14} />
          <input placeholder="Search materials…" value={search} onChange={e => setSearch(e.target.value)} />
        </div>
        <select className="form-control" style={{ width: "auto" }} value={sub} onChange={e => setSub(e.target.value)}>
          <option value="all">All Subjects</option>
          {subjects.map(s => <option key={s} value={s}>{s}</option>)}
        </select>
      </div>

      {loading ? <div className="loading-center"><div className="spinner" /></div> :
        filtered.length === 0 ? <div className="card"><div className="empty-state"><div className="empty-icon">📚</div><div className="empty-title">No materials yet</div><div className="empty-desc">Your teachers haven't uploaded materials yet.</div></div></div>
        : (
          <div className="g g3">
            {filtered.map(m => {
              const t  = m.type || m.fileType || "other";
              const cl = TYPE_COLOR[t] || "#6b7280";
              return (
                <div key={m.id} className="card"
                  onMouseEnter={e => e.currentTarget.style.boxShadow = "0 4px 14px rgba(0,0,0,.08)"}
                  onMouseLeave={e => e.currentTarget.style.boxShadow = "0 1px 4px rgba(0,0,0,.06)"}>
                  <div style={{ height: 3, background: cl }} />
                  <div style={{ padding: "14px 16px" }}>
                    <div style={{ display: "flex", gap: 12, alignItems: "flex-start", marginBottom: 10 }}>
                      <div style={{ width: 44, height: 44, borderRadius: "var(--r8)", background: cl + "15", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "1.4rem", flexShrink: 0 }}>
                        {TYPE_ICON[t] || "🔗"}
                      </div>
                      <div style={{ flex: 1, minWidth: 0 }}>
                        <h4 style={{ fontSize: ".9rem", fontWeight: 700, marginBottom: 4, lineHeight: 1.3 }}>{m.title}</h4>
                        <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
                          <span className="badge badge-blue" style={{ fontSize: ".68rem" }}>{m.subject}</span>
                          <span style={{ fontSize: ".68rem", fontWeight: 700, padding: "2px 7px", borderRadius: 20, background: cl + "15", color: cl, textTransform: "uppercase" }}>{t}</span>
                        </div>
                      </div>
                    </div>
                    {m.description && <p style={{ fontSize: ".8rem", color: "var(--gray-500)", marginBottom: 10, lineHeight: 1.5 }}>{m.description}</p>}
                    <div style={{ fontSize: ".73rem", color: "var(--gray-400)", marginBottom: 12 }}>
                      By {m.uploadedBy} · {m.uploadedAt ? format(toDate(m.uploadedAt), "MMM d, yyyy") : ""}
                    </div>
                    {(m.fileUrl || m.linkUrl) ? (
                      <a href={m.fileUrl || m.linkUrl} target="_blank" rel="noreferrer" className="btn btn-primary btn-sm" style={{ width: "100%", textDecoration: "none" }}>
                        <FiExternalLink size={13} /> Open Material
                      </a>
                    ) : (
                      <button className="btn btn-ghost btn-sm" disabled style={{ width: "100%" }}>No link available</button>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        )}
    </div>
  );
}
